import { ABTestExperiment } from './types'

export const NO_EXPERIMENT_RESULT: ABTestExperiment = {
  experiment: null,
  participating: false,
  alternative: null,
}
